import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { UmbracoImage } from '@models/umbraco.model';
import { ImageComponent } from '../../../@shared/image/image/image.component';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-gift-option',
    templateUrl: './gift-option.component.html',
    styleUrls: ['./gift-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, NgIf, SvgIconComponent, ImageComponent]
})
export class GiftOptionComponent {
    @Input() public variantNo: string;
    @Input() public name?: string;
    @Input() public displayPrice?: string;
    @Input() public image: UmbracoImage;

    @Input() public isSelected?: boolean;

    @Output() public optionClick = new EventEmitter<string>();
}
